import { useContext } from 'react';
import clsx from 'clsx';

import WorkTemplateContext from '@atom/components/workTemplate/WorkTemplateContext';
import { Summary } from '@atom/types/work';
import { InheritedComponentType } from '@atom/types/workTemplate';
import { isComponentInherited } from '@atom/utilities/workTemplateUtilities';

import classes from './workTemplateInfo.module.css';

interface Props {
  summary: Summary;
}

const WorkTemplateSummaryRow = ({ summary }: Props) => {
  const { workTemplate } = useContext(WorkTemplateContext);

  const isInherited = isComponentInherited(
    InheritedComponentType.SUMMARY,
    workTemplate?.inheritedComponents || [],
  );

  return (
    <>
      <div className={classes.summaryItemHeader}>
        <div
          className={clsx(
            classes.summaryTitle,
            isInherited && classes.disabled,
          )}
        >
          {summary.title}
        </div>
      </div>
      <div
        className={clsx(
          classes.summaryItemContent,
          isInherited && classes.disabled,
        )}
      >
        {summary.contents}
      </div>
    </>
  );
};

export default WorkTemplateSummaryRow;
